import { render, staticRenderFns } from "./FullSwapModalWrapper.vue?vue&type=template&id=7ffd661e&scoped=true"
import script from "./FullSwapModalWrapper.vue?vue&type=script&lang=js"
export * from "./FullSwapModalWrapper.vue?vue&type=script&lang=js"
import style0 from "./FullSwapModalWrapper.vue?vue&type=style&index=0&id=7ffd661e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffd661e",
  null
  
)

export default component.exports